module.exports = __webpack_public_path__ + "static/media/Logo_white_Desktop.2a674b21.svg";